import React from "react";
import PropTypes from "prop-types";
import { varsomePremiumUrl } from "../../../common/helpers/Urls";

const getIcon = (type) => {
  if (type === "pie") {
    return "fa fa-pie-chart";
  }
  if (type === "bar") {
    return "fa fa-bar-chart";
  }

  return "fa fa-bar-chart";
};

function PremiumChart({ name, type }) {
  return (
    <div className="chart">
      <div className="custom-container">
        <div className="chart--premium">
          <i className={getIcon(type)} aria-hidden="true" />
          <p>
            {name}
            {" data available to "}
            <a href={varsomePremiumUrl} target="_blank">
              VarSome Premium
            </a>
            {" subscribers."}
          </p>
        </div>
      </div>
    </div>
  );
}

PremiumChart.propTypes = {
  name: PropTypes.string,
  type: PropTypes.oneOf(["pie", "bar"]),
};

PremiumChart.defaultProps = { name: "this chart", type: "bar" };

export default PremiumChart;
